import React from 'react';
import { useParams } from 'react-router-dom';

import Paragraph from '@sv-support-sdk/ui-components/src/components/Typography/Paragraph';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import Breadcrumbs from '../../Navigation/Breadcrumbs';
import PageContentInner from '../../Layout/Page/PageContentInner';
import CategoryBlockList from './CategoryBlockList';

import { createBreadcrumbs } from '../../../helpers/breadcrumbs';
import { useAppSelector } from '../../../store/hooks';
import { categoryBySlugSelector, selectCategories } from '../../../store/selectors/helpCenter';

const SingleCategoryBlock = () => {
  const params = useParams();
  const category = useAppSelector((state) => categoryBySlugSelector(state, params.category));
  const categories = useAppSelector(selectCategories);

  if (!category) return null;

  const breadcrumbs = createBreadcrumbs({
    categories,
    category,
    isLastDisabled: true,
  });

  return (
    <PageContentInner>
      <Breadcrumbs items={breadcrumbs} className="indent-md-bottom" />
      <Headline className="indent-sm-bottom">{category.name}</Headline>
      <Paragraph>{category.description}</Paragraph>
      <CategoryBlockList category={category} className="indent-3xl-top" />
    </PageContentInner>
  );
};

export default SingleCategoryBlock;
